<template>
  <b-container fluid>
    <h1 align="center" id="jump-to-header">
      {{heading || "Table"}}
      <b-button v-b-toggle.collapse-options variant="outline-primary">...</b-button>
      <b-button-group size="sm" class="ml-3">
        <b-button variant="danger" size="sm" v-if="showFilterClear" @click="clearFilter" v-b-tooltip.hover.right title="Clear Filters">
          <b-icon-arrow-clockwise animation="spin" class="rounded-circle bg-danger" variant="light"></b-icon-arrow-clockwise>
        </b-button>
      </b-button-group>
    </h1>
    <!-- User Interface controls -->
    <b-card bg-variant="light">
      <b-collapse id="collapse-options" class="mt-2">
        <b-row>
          <b-button left v-b-toggle.collapse-1 variant="outline-secondary" size="sm">
            <!-- Find... -->
            <b-icon-search> aria-label="Search"></b-icon-search>
          </b-button>
          {{">>" + JSON.stringify(filterParams()).replace(/{|}|"/g, "").replace(/,/g,", ")}}
        </b-row>
      </b-collapse>
    </b-card>
    <b-collapse id="collapse-1" class="mt-2">
      <b-card bg-variant="light">
        <b-row>
          <b-col lg="6" class="my-1">
            <b-form-group
              label="Sort"
              label-for="sort-by-select"
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
              v-slot="{ ariaDescribedby }"
            >
              <b-input-group size="sm">
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  :aria-describedby="ariaDescribedby"
                  class="w-75"
                >
                  <template #first>
                    <option value="">-- none --</option>
                  </template>
                </b-form-select>

                <b-form-select
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  :aria-describedby="ariaDescribedby"
                  size="sm"
                  class="w-25"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col lg="6" class="my-1" v-for="(item,index) in filter_list" :key="index">
            <b-form-group v-if="item.type === 'boolean'" :label="item.label">
                <b-form-select v-model="item.model" class="mb-0" size="sm">
                  <b-form-select-option value="">Unfiltered</b-form-select-option>
                  <b-form-select-option value="true">True</b-form-select-option>
                  <b-form-select-option value="false">False</b-form-select-option>
              </b-form-select>
            </b-form-group>
            <b-form-group v-if="item.type === 'string'"
              :label="item.label"
              label-for="filter-input"
              label-cols-sm="6"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="item.model"
                  type="search"
                  placeholder="String Search"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group v-if="item.type === 'enumerated-list'"
              :label="item.label"
              label-for="filter-input"
              label-cols-sm="6"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-form-select v-model="item.model" :options="item.list" multiple :select-size="4"></b-form-select>
            </b-form-group>
            <b-form-group v-if="item.type === 'number-list'"
              :label="item.label"
              label-for="filter-input"
              label-cols-sm="6"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                  id="filter-input"
                  v-model="item.model"
                  type="search"
                  placeholder="Number Search"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button block variant="primary" @click="callSearch">Find</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>
  </b-container>
</template>

<script>
import { BIconSearch, BIconArrowClockwise } from 'bootstrap-vue'
import {amsSchema} from '@/schema'

export default {
  components: { 
    BIconSearch,
    BIconArrowClockwise
  },
  props: {
    ams_type: {
      Type: String
    },
    ams_fields: {
      Type: Array
    },
    heading: {
      Type: String
    }
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      filter_list: []
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.ams_fields.filter(f => f.sortable).map(f => {
          return { text: f.label, value: f.key }
        })
    },
    showFilterClear() {
      let filtering = JSON.stringify(this.filterParams())
      filtering.replace("[]", "")
      window.console.log("ShowFilterClear")
      window.console.log(filtering)
      return filtering.replace("[]", "").length > 2 /* "{}" */
    }
  },
  methods: {
    callSearch () {
      let sorting = null
      if(this.sortBy.length) {
        sorting = this.sortDesc ? '-' : '+'
        sorting += this.sortBy.substring(11).replace(/-/g, '_') // 'attriubutes. offset substring
      }
      this.$emit('searchFor', {
        sort: sorting,
        ... this.filterParams()
      })
    },
    filterParams() {
      const obj = {}  // Consider Reduce operation
      let param_list = this.filter_list.filter(f => f.model?.length > 0)
      param_list.forEach(param => {
        const key = param.label
        obj[key] = param.model
      })
      return obj
    },
    clearFilter() {
      let param_list = this.filter_list.filter(f => f.model)
      param_list.forEach(param => {
        if(param.type == 'enumerated-list') {
          param.model = []
        }
        else {
          param.model = undefined
        }
        // param.model = undefined
      })
      this.callSearch()
    }
  },
  mounted() {
    const included_obj = amsSchema.find( 
      el =>  
      el.type === this.ams_type
    )
    this.filter_list = included_obj.filters ? included_obj.filters : []
  }
}
</script>

